import { render } from "./hadrianLoader.vue?vue&type=template&id=5b5b6a8c&ts=true"
import script from "./hadrianLoader.ts?vue&type=script&lang=ts"
export * from "./hadrianLoader.ts?vue&type=script&lang=ts"

import "./hadrianLoader.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__